var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const transformPayload = (searchedDocs) => {
    return searchedDocs.map(searchedDoc => {
        const newSource = {
            fileId: searchedDoc.source.fileId,
            fileName: searchedDoc.source.fileName,
            metadataFields: [],
        };
        for (const [index, val] of Object.entries(searchedDoc.source)) {
            if (index === 'fileId' || index === 'fileName' ||
                index === 'organizationId' || index === 'linesOfBusiness')
                continue;
            if ((typeof val === 'string' && val.length === 0) ||
                (Array.isArray(val) && val.length === 0))
                continue;
            const mf = { name: index, value: val };
            newSource.metadataFields.push(mf);
        }
        return Object.assign(Object.assign({}, searchedDoc), { source: newSource });
    });
};
const searchDocuments = (ws, searchFilters, pageNumber) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const payload = {
        searchText: searchFilters.searchText,
        pageSize: 100,
        pageNumber,
        includeExpired: !!((_a = searchFilters.advancedFilters) === null || _a === void 0 ? void 0 : _a.includeExpired),
    };
    if ((_b = searchFilters.advancedFilters) === null || _b === void 0 ? void 0 : _b.includeExpired) {
        delete searchFilters.advancedFilters.includeExpired;
    }
    if (searchFilters.advancedFilters) {
        payload.advancedFilters = searchFilters.advancedFilters;
    }
    const documentResults = yield new Promise(resolve => {
        ws.send('request:/document-search:post', payload, (data) => resolve(data));
    });
    if (documentResults.statusCode === 200) {
        if (documentResults.payload) {
            if (documentResults.queryInfo) {
                return {
                    searchedDocs: transformPayload(documentResults.payload),
                    query: documentResults.queryInfo,
                };
            }
            throw Error('Document Search Response missing Query Info');
        }
        throw Error('Document Search Response missing Clauses');
    }
    throw Error(`Document Search Response returned status code: ${documentResults.statusCode}`);
});
export default searchDocuments;
